<template>
    <div>
        <div class="list-category top-header-main">
            <campaign-list
                :lbl="lbl"
                :isLoading='isLoading'
                :initListConfig="campaignListConfig"
                :initFilterConfig="campaginListFilterConfig"
                :busEvent="busCategory"
                @toggleLoading="toggleLoading($event)">
            </campaign-list>
        </div>
        <Footer />
    </div>
</template>
<script>
import Vue from 'vue'
// helper
import Locale from '@/helper/locale/locale.js';
// core
import {
    CampaignListConfigBuilder,
    CampaignListFilterConfigBuilder
} from "@/core/Campaign/model/CampaignConfigModel.js";
import { CategoryConfigBuilder } from "@/core/Campaign/model/CategoryConfigModel.js";
import ConfigManager from "@/config/ConfigManager.js";
// component
import CampaignList from "../component/CampaignList.vue";
import Footer from "@/components/Footer/Footer.vue";

export default {
    name: 'Category',
    components: {
        CampaignList,
        Footer,
    },
    data: function () {
        return {
            lbl: Locale.getLbl(),
            locale: Locale.getLocaleCode(),
            isLoading: false,
            //config
            categoryConfig: {},
            campaignListConfig: {},
            campaginListFilterConfig: {},
            //bus
            busCategory: new Vue()
        };
    },
    created: function () {
        this.initialCategory();
    },
    methods: {
        changeCategory: function (category) { 
            this.initialCampaign(category);
        },
        initialCategory: function () {
            var configStr = ConfigManager.getCategoryMenu();
            var categoryConfig = new CategoryConfigBuilder()
                .setConfig(configStr)
                .setLocale(this.locale);

            this.categoryConfig = categoryConfig.create();
        },
        initialCampaign: function (category) {
            this.campaignListConfig = {};
            this.campaginListFilterConfig = {};

            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(category.list_config)
                .setTop(25);

            if (category.id)
                listConfig.setCatId(category.id);

            this.campaignListConfig = listConfig.create();

            var filterConfig = new CampaignListFilterConfigBuilder();
            this.campaginListFilterConfig = filterConfig.create();

            this.busCategory.$emit('reInitList', {
                listConfig: this.campaignListConfig,
                filterConfig: this.campaginListFilterConfig
            });
        },
        toggleLoading: function (isLoading) {
            this.isLoading = isLoading;
        },
    }
}
</script>
<style lang="scss">
.list-category {
    .owl-nav {
        display: none;
    }
    .owl-dots {
        display: none;
    }
}
</style>
